import { Button } from "react-bootstrap";
import parse from 'html-react-parser';
import { useTranslation } from "react-i18next";
import { Overlay } from "./Overlay";

interface ConfirmationDialogProps {
    message:  string;
    confirmLabel: string;
    confirmCallback: CallableFunction;
    cancelLabel: string;
    cancelCallback: CallableFunction;
}


export default function ConfirmationDialog(props: ConfirmationDialogProps) {
    const { t } = useTranslation();
    
    const handleCancel = () => {
        props.cancelCallback();
    }

    const handleConfirm = () => {
        props.confirmCallback();
    }

    return (
        <Overlay title={t("Delete")} onClose={handleCancel} className="confirmation-dialog-container confirmation-dialog">
            <p>
                { parse(props.message) }
            </p>
            <div className="actions">
                <Button className="btn btn-primary" onClick={ handleConfirm }>{ props.confirmLabel }</Button>
                <Button className="btn btn-warning" onClick={ handleCancel }>{ props.cancelLabel }</Button>
            </div>
        </Overlay>
    );
}